export enum ProcessComponentsModes {
  VISUALIZATION = "visualization",
  MODIFICATION = "modification",
}